/* import __COLOCATED_TEMPLATE__ from './select-kit-create-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import TEMPLATE from "./select-kit-create-row.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, SelectKitRowComponent.extend({
  classNames: "create"
}));